import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosMisviaticosSolicitarComponent {
  data = {}
  proyecto = {}
  solicitando = false
  mostrarViaje = false
  onChange

  constructor (ViaticosSolicitudAnticipoService, ViaticosService, $state) {
    this.ViaticosSolicitudAnticipoService = ViaticosSolicitudAnticipoService
    this.ViaticosService = ViaticosService
    this.$state = $state
  }

  getColaborador (data) {
    this.data.colaborador = data.colaborador
    this.data.operadora = {
      nombre: data.colaborador.empresa,
      rfc: data.colaborador.empresa_rfc,
    }
    this.proyecto = data.proyecto
  }

  setViaje (data) {
    this.data.viaje = Object.assign({}, data)
  }

  irViatico () {
    this.$state.go('^.viatico', {viatico_id: this.viaticoId})
  }

  salir () {
    this.$state.go('.^')
  }

  solicitar (data) {
    if (!data) return
    this.respuesta = data[0]
    this.viaticoId = this.respuesta.viatico_id
  }
}

module.component('viaticosMisviaticosSolicitar', {
  controller: ViaticosMisviaticosSolicitarComponent,
  template,
  bindings: {
    viaticoId: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/misviaticos/solicitar/component.js